import React, { useCallback, useEffect, useRef, useState } from 'react';
import Timeline from 'react-visjs-timeline';
import { TimelineOptions,  TimelineItem} from 'vis-timeline';

import { Box, Button, CircularProgress, Divider, Grid, Menu, MenuItem, Typography} from '@material-ui/core';
import moment from 'moment';
import { useDebounce } from '../../hooks/useDebounce';
import PlayerLayout from "../layout/player-layout";
import Card from './components/card';
import Filter from './components/filter';
import { CardsContainer, ContextMenuDescTypography, ContextMenuDownloadButton, ContextMenuInfoTypography, ContextMenuTypeTypography, CuttingButton, CuttingButtonTypography, CuttingTimecodeTypography, DateReference, IconsWrapper, NavigationButton, NavigationButtonTypography, PlayerArea, PlayerControllerContainer, PlayPauseButton, SearchButton, SearchButtonTypography, SearchKeyboardDateTimePicker, SearchWrapper, TimeControllerContainer, TimelineWrapper, TimeReference, WhiteTextTypography, ZoomButton } from './styles';
import { render } from 'react-dom'
import 'moment/locale/pt-br';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';

import { EventAvailable, EventBusy } from '@material-ui/icons';

import { ZoomIn, ZoomOut, PlayArrow, Pause } from '@material-ui/icons';

import MediaproLogo from '../../assets/adchecking-mediapro.svg';
import { MediaproIcon } from '../login/styles';


import DateFnsUtils from '@date-io/date-fns';
import isValid from 'date-fns/isValid';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { isGloboCurrentApp } from '../../utils/get-app-env'

import ReactHlsPlayer from 'react-hls-player';
import SimpleDialog from '../../components/Dialog';
import { useDialog } from '../../contexts/dialog';
import { axiosCallHandler } from '../../infra/axiosHelper';

import SearchIcon from '@material-ui/icons/Search';

import { ptBR } from '@material-ui/core/locale';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { BASE_URL } from "../../../src/services/download-media-api";
import axios from '../../services/api';
import { getLocalStorageData } from '../../utils/auth';
import { UserData } from '../player/types';
import AudioDialog from './components/dialog';
import './style.css';
import { ButtonContained, ButtonOutlined } from './components/dialog/styles';
import { formatTimestampToIsoNumber } from '../../utils/date-time';
import { CustomTimelineItem, ExhibitionReportProps, generateTimelineRecognitionItems, GetExhibitionReportType, DispatcherCreativeItem,generateCreativeListByRecognitions } from '../../utils/timeline';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

type ClippingSourceShape = {
  name: string;
  channel_label: string;
  channel_name: string;
  location_label: string;
  location_name: string;
  enabled: boolean;
}

type AudioProps = {
  address: string;
  uuid: string;
}

type PromiseAudioProps = {
  data: AudioProps;
}

enum NavigateToFuture {
  '30_SECONDS' = 30000,
  '3_MINUTES' = 180000,
  '30_MINUTES' = 1800000,
  '1_DAY' = 86400000
}

enum NavigateToPast {
  '1_DAY' = -86400000,
  '30_MINUTES' = -1800000,
  '3_MINUTES' = -180000,
  '30_SECONDS' = -30000,
}

type CuttingIconProps = {
  icon: 'available' | 'busy',
  disabled?: boolean;
}

type ClipAreaProps = {
  id: number;
  type: string;
  content: string;
  start: Date | number | moment.Moment;
  end: Date | number | moment.Moment;
  editable: {
    updateTime: boolean;
  }
  className: string;
  selectable: boolean;
}

type ContextMenuMousePosition = {
  mouseX: number | null,
  mouseY: number | null,
}

const initialState = {
  mouseX: null,
  mouseY: null,
};

const dateTimePickerFormat = "YYYY-MM-DD HH:mm:ss"

export const AudioPlayer = () => {

  const dialogContext = useDialog();

  const [currentClipToDisplay, setCurrentClipToDisplay] = useState<ClippingSourceShape & { playerLabel: string } | undefined>();
  const [clippings, setClippings] = useState<ClippingSourceShape[] | []>([]);
  const [filter, setFilter] = useState('');
  const [filteredClips, setFilteredClips] = useState<ClippingSourceShape[] | []>([]);
  const debouncedFilterTerm = useDebounce(filter, 600);
  const [audioUrl, setAudioUrl] = useState('');

  const [isLoadingNewMidia, setIsLoadingNewMedia] = useState(true);
  const [disableDownloadButton, setDisableDownloadButton] = useState(false);
  const trimUrlPattern = `${BASE_URL}/clips/{clipId}/trim/{seek}/{to}/download_audio`;
  const [selectedDate, setSelectedDate] = useState(moment().locale('pt-br').format(dateTimePickerFormat));

  //### Timeline
  const timelineRef = useRef<any>(null);

  const [isCriticalModalOpen, setIsCriticalModalOpen] = useState(false);
  const [searchConfirmationModal, setSearchConfirmationModal] = useState(false);
  const [changeSourceModal, setChangeSourceModal] = useState(false);

  const [currentZoomIndex, setCurrentZoomIndex] = useState(1); //Controla o index do zoom atual
  const [recognitions, setRecognitions] = useState<CustomTimelineItem[] | []>([]);
  const timelineRecognitions = useRef<CustomTimelineItem[]>([]);
  const currentTimelineRecognition = useRef<CustomTimelineItem | undefined>(undefined);
  const timelineCreatives = useRef<DispatcherCreativeItem[]>([]);
  const currentTimelineCreative = useRef<DispatcherCreativeItem | undefined>(undefined);
  const currentZoomIndexRef = useRef(currentZoomIndex);
  currentZoomIndexRef.current = currentZoomIndex;

  const exhibitionWindowCurrentTime = useRef(new Date());
  const exhibitionWindowCurrentTimeTimeout = useRef<any>(undefined);

  //const [ZOOM] = useState([180, 30, 10, 3]);
  const EXHIBITION_WINDOW_DURATION = [7200, 3600, 1200, 360];
  const CLIP_WINDOW_DURATION_IN_SECONDS = 10800;
  const FIXED_CRITICAL_INTERVAL = 0 //10 min
  const DELAY_TO_LIVE = 1800; // 30 min

  const [contextMenuPosition, setContextMenuPosition] = useState<ContextMenuMousePosition>(initialState);

  const lastSelectedSourceByUser = useRef<ClippingSourceShape & { playerLabel: string } | undefined>(undefined);
  const currentSelectedSourceByUser = useRef<ClippingSourceShape & { playerLabel: string } | undefined>(undefined);

  const clipWindow = useRef({
    currentStart: 0,
    currentEnd: 0,
    durationInSeconds: CLIP_WINDOW_DURATION_IN_SECONDS,
    currentSource: 'POAATL',
    clipUUID: '',
    criticalStart: 0,
    criticalEnd: 0,
  });
  const clipWindowMockDataToUpdateClipWindowAfterConfirmationModal = useRef({
    currentStart: 0,
    currentEnd: 0,
    criticalStart: 0,
    criticalEnd: 0
  })

  const exhibitionWindowMockDataToReturnAfterCancelModalRef = useRef({
    currentStart: 0,
    currentEnd: 0,
    currentTime: 0,
  });

  const exhibitionWindowMockDataToUpdateExhibitionWindowAfterConfirmationModal = useRef({
    currentStart: 0,
    currentTime: 0,
    currentEnd: 0,
    isFuture: false
  });
  const [exhibitionWindow, setExhibitionWindow] = useState({
    currentStart: 0,
    currentTime: 0,
    currentEnd: 0
  });
  const exhibitionWindowRef = useRef({
    currentStart: 0,
    currentTime: 0,
    currentEnd: 0
  })
  const [timelineOptions] = useState<TimelineOptions>({
    width: '100%',
    height: '100px',
    stack: false,
    showMajorLabels: true,
    showCurrentTime: false,
    autoResize: false,
    zoomable: false,
    orientation: 'top',
    // horizontalScroll: false,
    // moveable: false,
    zoomFriction: 5,
    zoomMin: 360000,
    zoomMax: 7200000,
    type: 'range',
    locales: {
      'pt_BR': {
        current: 'pt_BR',
        time: 'hora',
      }
    },
    locale: 'pt_BR',
    showTooltips: true,
    
    tooltip: {
      template: function (item: TimelineItem, data?: TimelineItem) {
        const recognition = timelineRecognitions.current.find(rec => 
          rec.id === item.id
        );

        const creative =  timelineCreatives.current.find(creative =>
          String(creative.external_id) === recognition?.audio_key
        )

        if (!creative) return "";

        return '<div class="tooltip-container"><div>' + creative?.metadata.title + '</div><div>' + creative?.metadata.advertiser + '</div><div>' + creative?.metadata.duration + '</div></div>'; 
      },
      overflowMethod: "cap",
      delay: 100
    }
  });
  const hasCustomId = useRef(false);


  //### Player
  type PlayerStatus = 'loading' | 'loaded' | 'playing' | 'paused'
  const playerRef = useRef<any>(null);

  //const playerStatus = useRef<PlayerStatus>("loading");
  const [currentPlayerStatus, setCurrentPlayerStatus] = useState<PlayerStatus>("loading"); //Controla o index do zoom atual
  const playerStatus = useRef(currentPlayerStatus);

  const wasDragged = useRef(false);
  const lastStatusBeforeDrag = useRef<PlayerStatus>("playing");

  //###  Clip
  //const [clipReportList, setClipReportList] = useState<ExhibitionReportProps[] | []>([]);
  const [isClipDialogOpen, setIsClipDialogOpen] = useState(false);
  const [cuttingMark, setCuttingMark] = useState({
    start: 0,
    end: 0
  });
  const isSeekingToDownlod = useRef(false);
  const [formattedClipCutDuration, setFormattedClipCutDuration] = useState('00:00');
  const [hasSelectedDate, setHasSelectedDate] = useState(true);
  const [searchTimestampSelectedByUser, setSearchTimestampSelectedByUser] = useState(0);

  const getCurrentEpoch = () => new Date().getTime();

  function isFutureTimestamp(timestamp: number) {
    return timestamp + (DELAY_TO_LIVE * 1000) > getCurrentEpoch();
  }

  function getDelayToLiveInSeconds(timestamp: number) {
    return isFutureTimestamp(timestamp) ? DELAY_TO_LIVE : 0 //30 min em segundos
  }

  function estimateDateTimeFrom(timestamp: number) {
    let delayToLive = getDelayToLiveInSeconds(timestamp);
    let dateTimeFrom = timestamp - ((EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] + delayToLive) * 1000);
    let date = new Date(dateTimeFrom);

    date.setMilliseconds(0);

    return date;
  }
/*
  function estimateDateTimeTo(timestamp: number) {
    let delayToLive = getDelayToLiveInSeconds(timestamp);
    let dateTimeTo = timestamp - (delayToLive * 1000);
    let date = new Date(dateTimeTo);

    date.setMilliseconds(0);

    return date;
  }*/

  const estimateCurrentDateTime = (timestamp: number) => {
    let delayToLive = getDelayToLiveInSeconds(timestamp);
    let currentTime = timestamp - ((EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) + delayToLive) * 1000;
    let date = new Date(currentTime);

    date.setMilliseconds(0);

    return date;
  }

  const estimateCurrentDateTimeWithoutDelayToLive = (timestamp: number) => {

    let currentTime = timestamp - ((EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2)) * 1000;
    let date = new Date(currentTime);

    date.setMilliseconds(0);

    return date;
  }

  //ExhibitionWindow
  function estimateExhibitionWindowsCurrentStartByCurrentTime(timestamp: number) {
    return timestamp - (EXHIBITION_WINDOW_DURATION[currentZoomIndex] / 2) * 1000;
  }

  function estimateExhibitionWindowsCurrentEndByCurrentTime(timestamp: number) {
    return timestamp + (EXHIBITION_WINDOW_DURATION[currentZoomIndex] / 2) * 1000;
  }

  //ClipWindow Area
  function estimateClipWindowCurrentStartByCurrentTime(currentTimestamp: number) {
    let exhibitionStart = estimateExhibitionWindowsCurrentStartByCurrentTime(currentTimestamp);
    return exhibitionStart - FIXED_CRITICAL_INTERVAL * 1000
  }

  function estimateClipWindowsCurrentEndByCurrentTimeByWindowsCurrentStart(clipWindowCurrentStartTimestamp: number) {
    return clipWindowCurrentStartTimestamp + clipWindow.current.durationInSeconds * 1000;
  }

  //Critical Area
  function estimateClipWindowsCriticalStartByCurrentTime(timestamp: number) {
    return estimateExhibitionWindowsCurrentStartByCurrentTime(timestamp);
  }

  function estimateClipWindowsCriticalEndByCurrentTime(timestamp: number) {
    return estimateClipWindowsCurrentEndByCurrentTimeByWindowsCurrentStart(timestamp) - FIXED_CRITICAL_INTERVAL * 1000
  }

  function handleZoomIn() {
    if (currentZoomIndex === 3) {
      return;
    }
    let currentIndexCount = Math.min(currentZoomIndexRef.current + 1, 3);
    setCurrentZoomIndex(currentIndexCount);
    setTimelineWindow(EXHIBITION_WINDOW_DURATION[currentIndexCount] / 2);
  }

  function handleZoomOut() {
    if (currentZoomIndex === 0) {
      return;
    }
    let currentIndexCount = Math.max(currentZoomIndexRef.current - 1, 0);
    setCurrentZoomIndex(currentIndexCount);
    setTimelineWindow(EXHIBITION_WINDOW_DURATION[currentIndexCount] / 2);
  }

  const getClip = (source: string, dateTimeFrom: number, duration: number) => {
    setIsLoadingNewMedia(true);
    let date = new Date(dateTimeFrom);
    date.setMilliseconds(0);
    return axios.post<AudioProps>(`/clips?source_name=${source}&datetime_from=${date.getTime()}&duration=${duration}`);
/*
    return new Promise<PromiseAudioProps>((resolve => {
      const res = {} as PromiseAudioProps;
      const data = {} as AudioProps;
      data.address = "http://189.4.83.83:8001/POAATL/473e2072-921c-4659-91d0-edcac11aa396/index.m3u8";
      data.uuid = "473e2072-921c-4659-91d0-edcac11aa396";
      res.data = data;
      setTimeout(() => {
        resolve(res);
      }, 2000);
    }));
    */
    
  }

  const getExhibitionReport = async ({ source, dateFrom, dateTo, filter = ['CERTAIN', 'UNCERTAIN', 'UNKNOWN'] }: GetExhibitionReportType) => {
    const response = await axios.get<ExhibitionReportProps[]>(`${process.env.REACT_APP_BASE_URL}/report-manager/sources/${source}/recognitions?start_date_time_from=${dateFrom}&start_date_time_to=${dateTo}`);
    
    /*const response = await axios.get<ExhibitionReportProps[]>(`https://api.gravacaolinear.mediapro.com.br/report-manager/sources/${source}/recognitions?start_date_time_from=${dateFrom}&start_date_time_to=${dateTo}`);*/

    return response.data.filter(data => filter?.includes(data.status))
  }

  const loadClippingSourcesAndRenderFirstClip = () => {
    if (!currentClipToDisplay) {
      playerStatus.current = 'loaded';
      return;
    }

    let clipWindowStart = getCurrentEpoch() - (DELAY_TO_LIVE * 1000) - (clipWindow.current.durationInSeconds! * 1000);
    let clipWindowEnd = getCurrentEpoch() - DELAY_TO_LIVE * 1000;

    let criticalStart = clipWindowStart + (FIXED_CRITICAL_INTERVAL * 1000);
    let criticalEnd = clipWindowEnd - (FIXED_CRITICAL_INTERVAL * 1000);

    let exhibitionWindowEnd = getCurrentEpoch() - (DELAY_TO_LIVE * 1000) - (clipWindow.current.durationInSeconds! * 1000) + (EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] * 1000) + (FIXED_CRITICAL_INTERVAL * 1000);
    let exhibitionWindowStart = estimateDateTimeFrom(exhibitionWindowEnd).getTime();
    let exhibitionWindowCurrent = estimateCurrentDateTime(exhibitionWindowEnd).getTime();

    clipWindow.current.currentStart = clipWindowStart;
    clipWindow.current.currentEnd = clipWindowEnd;
    clipWindow.current.criticalStart = criticalStart;
    clipWindow.current.criticalEnd = criticalEnd;

    exhibitionWindowRef.current = {
      currentStart: exhibitionWindowStart,
      currentTime: exhibitionWindowCurrent,
      currentEnd: exhibitionWindowEnd
    }

    setExhibitionWindow({
      currentStart: exhibitionWindowStart,
      currentTime: exhibitionWindowCurrent,
      currentEnd: exhibitionWindowEnd
    });

    exhibitionWindowMockDataToReturnAfterCancelModalRef.current = {
      currentStart: exhibitionWindowStart,
      currentTime: exhibitionWindowCurrent,
      currentEnd: exhibitionWindowEnd
    }

    playerStatus.current = 'loaded';

    const clipNameAndLocationName = currentClipToDisplay.name.replace('-', '')

    getClip(clipNameAndLocationName, clipWindowStart, clipWindow.current.durationInSeconds!).then(res => {
      setAudioUrl(res.data.address);
      setIsLoadingNewMedia(false);
      const playerCurrentTime = Math.trunc((exhibitionWindowCurrent - clipWindowStart) / 1000);
      playerRef.current.currentTime = playerCurrentTime;

      //Caso não tenha o id criado ele adiciona, contrário a isto, ele edita
      if (!hasCustomId.current) {
        timelineRef?.current['$el'].addCustomTime(exhibitionWindowCurrent, 1);
        hasCustomId.current = true;
      } else {
        timelineRef?.current['$el'].setCustomTime(exhibitionWindowCurrent, 1);
      }

      setSelectedDate(moment(exhibitionWindowCurrent).locale('pt-br').format(dateTimePickerFormat));
      setHasSelectedDate(true);

      timelineRef?.current['$el'].setOptions({ start: exhibitionWindowStart, end: exhibitionWindowEnd });
      
      handlePlayButton();
      clipWindow.current.clipUUID = res.data.uuid;
      clipWindow.current.currentSource = clipNameAndLocationName;

      const dateFrom = formatTimestampToIsoNumber(clipWindowStart);
      const dateTo = formatTimestampToIsoNumber(clipWindowEnd);   
        
      
      getExhibitionReport({
        source: clipWindow.current.currentSource,
        dateFrom,
        dateTo,
        filter: ['CERTAIN']
      }).then(res => {
        timelineRecognitions.current = generateTimelineRecognitionItems(res);
        setRecognitions(timelineRecognitions.current);
        generateCreativeListByRecognitions(timelineRecognitions.current).then((response) => {
          timelineCreatives.current = response;
        });
        updateRedCriticalArea(criticalStart, criticalEnd);
      })

    }).catch(err => {
      setIsLoadingNewMedia(false);
      setCurrentClipToDisplay(undefined);
    })
  }
/*
  const updateTimelineRangeItems = (timelineItemsRef: any) => {
    const oldRangeItems = timelineItemsRef;
    const newRangeItems = [...oldRangeItems.criticals, ...oldRangeItems.clips, ...oldRangeItems.download];

    timelineRef?.current['$el'].setItems(newRangeItems);
  }*/
/*
  const timelineItemsRef = useRef({
    criticals: [] as ClipAreaProps[],
    clips: [] as ClipAreaProps[],
    download: [] as ClipAreaProps[]
  });*/

  const handleFilter = () => {
    if (debouncedFilterTerm === '') {
      setFilteredClips(clippings);
      return;
    }

    let filteredList = clippings.filter(clip =>
      clip.location_label.toLowerCase().includes(debouncedFilterTerm.toLowerCase()) ||
      clip.channel_label.toLowerCase().includes(debouncedFilterTerm.toLowerCase())
    );

    setFilteredClips(filteredList);
  }

  const setTimelineWindow = (timeInMinutes: number) => {
    let exhibitionWindowStart = moment(exhibitionWindowRef.current.currentTime).subtract(timeInMinutes, 'seconds');
    let exhibitionWindowEnd = moment(exhibitionWindowRef.current.currentTime).add(timeInMinutes, 'seconds');

    timelineRef?.current['$el'].setOptions({
      start: exhibitionWindowStart,
      end: exhibitionWindowEnd
    }
    )

    timelineRef.current['$el'].redraw();
  }

  const isWithinCriticalSpace = (timestamp: number) => {
    return timestamp < clipWindow.current?.criticalStart || timestamp > clipWindow.current?.criticalEnd;
  }

  const generateTimelineRangeItems = (criticalStart: number, criticalEnd: number, clipArea?: Date[]) => {
    
    let recognition = timelineRecognitions.current.find(rec => 
      rec.id === 1
    );
    if (!recognition) {
      timelineRecognitions.current.push({
        id: 1,
        audio_key: "0",
        type: 'range',
        content: "",
        start: new Date(new Date().getTime() - (86_400_000 * 2)),
        end: new Date(criticalStart),
        editable: {
          updateTime: false
        },
        className: 'proibido',
        selectable: false,
      })
    } else {
      recognition.start = new Date(new Date().getTime() - (86_400_000 * 2));
      recognition.end= new Date(criticalStart);
    }

    recognition = timelineRecognitions.current.find(rec => 
      rec.id === 2
    );

    
    if (!recognition) {
      timelineRecognitions.current.push({
        id: 2,
        audio_key: "0",
        type: 'range',
        content: "",
        start: new Date(criticalEnd),
        end: new Date(new Date().getTime() + 86_400_000),
        editable: {
          updateTime: false
        },
        className: 'proibido',
        selectable: false,
      })
    } else {
      recognition.start = new Date(criticalEnd);
      recognition.end= new Date(new Date().getTime() + 86_400_000);
    }
    
    if (clipArea) {
      let recognition = timelineRecognitions.current.find(rec => 
          rec.id === 3
      );
      if (!recognition) {
        timelineRecognitions.current.push({
          id: 3,
          audio_key: "0",
          type: 'range',
          content: "",
          start: clipArea[0],
          end: clipArea[1],
          editable: {
            updateTime: false
          },
          className: 'clip-download-area',
          selectable: false,
        })
      } else {
        recognition.start = clipArea[0];
        recognition.end= clipArea[1];
      }
    } else {
      let index = timelineRecognitions.current.findIndex(rec => rec.id === 3);
      
      if (index !== -1) {
        timelineRecognitions.current.splice(index, 1);
      }
    }
        
    return timelineRecognitions.current;
  }

  const updateRedCriticalArea = (currentCriticalStart: number, currentCriticalEnd: number) => {
    
    const timelineItemsList = generateTimelineRangeItems(currentCriticalStart, currentCriticalEnd);

    timelineRef?.current['$el'].setItems(timelineItemsList);
  }

  const lastSelectedSeekDate = useRef(0);

  const doubleClickHandler= (e: any) => {
    if (e.what !== "item") {
      return;
    }
    const recognition = timelineRecognitions.current.find(rec => 
      rec.id === e.item
    );
    
  }

  const contextmenuHandler= (e: any) => {
    if (e.what !== "item") {
      return;
    }
    currentTimelineRecognition.current = timelineRecognitions.current.find(rec => 
      rec.id === e.item
    );

    currentTimelineCreative.current = timelineCreatives.current.find(creative => {
      return String(creative.external_id) === currentTimelineRecognition.current?.audio_key;
    });

    if (!currentTimelineCreative.current) {
      return;
    }

    e.event.preventDefault();
    setContextMenuPosition({
      mouseX: e.event.clientX - 2,
      mouseY: e.event.clientY - 4,
    });
    
  }

  const handleCloseContextMenu = () => {
    setContextMenuPosition(initialState);
  };

  const rangeChangeHandler = (e: any) => {
    if (!e.byUser) {
      return;
    };

    let exhibitionCurrentTime = estimateCurrentDateTimeWithoutDelayToLive(e.end.getTime());
    timelineRef?.current['$el'].setCustomTime(moment(exhibitionCurrentTime), 1);

    exhibitionWindowCurrentTime.current = exhibitionCurrentTime

    if (exhibitionWindowCurrentTimeTimeout.current === undefined) {
      exhibitionWindowCurrentTimeTimeout.current = setTimeout(() => {

        exhibitionWindowRef.current = {
          currentStart: exhibitionWindowRef.current.currentStart,
          currentTime: exhibitionWindowCurrentTime.current.getTime(),
          currentEnd: exhibitionWindowRef.current.currentEnd
        }

        setExhibitionWindow({
          ...exhibitionWindowRef.current,
          currentTime: exhibitionWindowCurrentTime.current.getTime()
        });

        exhibitionWindowCurrentTimeTimeout.current = undefined;
        clearTimeout(exhibitionWindowCurrentTimeTimeout.current);
      }, 600)
    }

    if (isSeekingToDownlod.current) {
      let start = new Date(lastSelectedSeekDate.current);
      let end = exhibitionCurrentTime;

      if (moment(exhibitionCurrentTime).isBefore(lastSelectedSeekDate.current)) {
        start = exhibitionCurrentTime;
        end = new Date(lastSelectedSeekDate.current);
      }

      const criticalAreaStart = clipWindow.current.criticalStart;
      const criticalAreaEnd = clipWindow.current.criticalEnd;

      const clipArea = [start, end];

      if (!isWithinCriticalSpace(exhibitionCurrentTime.getTime())) {
        const formattedClipDownloadDuration = calculateDiffBetweenClipDates(start.getTime(), end.getTime());
        setFormattedClipCutDuration(formattedClipDownloadDuration);

        //Fazer a duration, que é a diferença de tempos in out para formatar certo
        const items = generateTimelineRangeItems(criticalAreaStart, criticalAreaEnd, clipArea);
        timelineRef?.current['$el'].setItems(items);
      }
    }

    if (!wasDragged.current) {
      lastStatusBeforeDrag.current = playerStatus.current;
      handleForcePause();
    }

    wasDragged.current = true;
  }

  function calculateDiffBetweenClipDates(start: number, end: number) {
    const diffInMs = end - start;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(diffInSeconds / 60);
    const seconds = diffInSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  const rangeChangedHandler = (e: any) => {
    if (!e.byUser) {
      return;
    };

    let exhibitionWindowCurrentTime = e.end.getTime() - (EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2 * 1000);

    let isFuture = isFutureTimestamp(exhibitionWindowCurrentTime);

    if (isFuture) {
      dialogContext.setDialogStatus(true);
      return;
    }
    exhibitionWindowCurrentTimeTimeout.current = undefined;
    clearTimeout(exhibitionWindowCurrentTimeTimeout.current);

    //let isFuture = isFutureTimestamp(e.end.getTime());
    //let currentTimestampReference = isFuture ? getCurrentEpoch() : e.end.getTime();
    let exhibitionCurrentStart = e.start;
    let exhibitionCurrentEnd = e.end;
    let exhibitionCurrentTime = new Date(exhibitionWindowCurrentTime);

    let clipCurrentStart = clipWindow.current.currentStart;

    handleGetLastPlayerStatus();
    wasDragged.current = false;

    if (isWithinCriticalSpace(exhibitionCurrentTime.getTime())) {
      handleForcePause();
      clipCurrentStart = exhibitionCurrentStart.getTime();
      let clipCurrentEnd = clipCurrentStart + (clipWindow.current.durationInSeconds * 1000);
      let currentCriticalStart = clipCurrentStart + (FIXED_CRITICAL_INTERVAL * 1000);
      let currentCriticalEnd = clipCurrentEnd - (FIXED_CRITICAL_INTERVAL * 1000);

      const clipWindowMockData = {
        currentStart: clipCurrentStart,
        currentEnd: clipCurrentEnd,
        criticalStart: currentCriticalStart,
        criticalEnd: currentCriticalEnd
      }

      const exhibitionWindowMockData = {
        ...exhibitionWindowRef.current,
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime(),
        isFuture: isFuture
      }

      //atualiza as referencias de mock para utilizar na confirmação do modal passada para o usuário
      clipWindowMockDataToUpdateClipWindowAfterConfirmationModal.current = clipWindowMockData;
      exhibitionWindowMockDataToUpdateExhibitionWindowAfterConfirmationModal.current = exhibitionWindowMockData;
      
      setIsCriticalModalOpen(true);
    } else {
      const exhibitionWindowMockDataToBeConsumedByCancelModal = {
        ...exhibitionWindowRef.current,
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime()
      }

      exhibitionWindowMockDataToReturnAfterCancelModalRef.current = exhibitionWindowMockDataToBeConsumedByCancelModal;

      exhibitionWindowRef.current = {
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime()
      }

      setExhibitionWindow({
        ...exhibitionWindowRef.current,
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime()
      });

      if (isFuture) {
        handleForcePause();
        timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
        timelineRef?.current['$el'].setCustomTime(exhibitionCurrentTime, 1);

        return;
      }

      const playerCurrentTime = Math.trunc((exhibitionCurrentTime.getTime() - clipCurrentStart) / 1000);
      playerRef.current.currentTime = playerCurrentTime;

      timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
      timelineRef?.current['$el'].setCustomTime(exhibitionCurrentTime, 1);
    }
  }

  async function handleConfirmationModalNewContent() {
    //confirmation modal logic
    setIsCriticalModalOpen(false);
    setIsLoadingNewMedia(true);

    const { currentStart, currentEnd, criticalStart, criticalEnd } =
      clipWindowMockDataToUpdateClipWindowAfterConfirmationModal.current;

    const clipNameAndLocationName = currentClipToDisplay?.name.replace('-', '');

    const res = await getClip(clipNameAndLocationName!, currentStart, clipWindow.current.durationInSeconds);
    
    setAudioUrl(res.data.address);
    setIsLoadingNewMedia(false);

    //#### atualiza as referencias do window utilizando a ref de mock da window
    clipWindow.current.currentStart = currentStart;
    clipWindow.current.currentEnd = currentEnd;
    clipWindow.current.criticalStart = criticalStart;
    clipWindow.current.criticalEnd = criticalEnd;
    clipWindow.current.currentSource = clipNameAndLocationName!;
    clipWindow.current.clipUUID = res.data.uuid;

    const dateFrom = formatTimestampToIsoNumber(currentStart);
    const dateTo = formatTimestampToIsoNumber(currentEnd);     
    
    getExhibitionReport({
      source: clipWindow.current.currentSource,
      dateFrom,
      dateTo,
      filter: ['CERTAIN']
    }).then(res => {
      timelineRecognitions.current = generateTimelineRecognitionItems(res);
      setRecognitions(timelineRecognitions.current);
      generateCreativeListByRecognitions(timelineRecognitions.current).then((response) => {
        timelineCreatives.current = response;
      });
      updateRedCriticalArea(criticalStart, criticalEnd);
        
    })
      
    /*updateRedCriticalArea(
      clipWindowMockDataToUpdateClipWindowAfterConfirmationModal.current.criticalStart,
      clipWindowMockDataToUpdateClipWindowAfterConfirmationModal.current.criticalEnd
    );*/

    

    const { currentStart: exhibitionCurrentStart, currentTime, currentEnd: exhibitionCurrentEnd, isFuture } =
      exhibitionWindowMockDataToUpdateExhibitionWindowAfterConfirmationModal.current;
      
    
    exhibitionWindowRef.current = {
      currentStart: exhibitionCurrentStart,
      currentTime: currentTime,
      currentEnd: exhibitionCurrentEnd
    }

    setExhibitionWindow({
      ...exhibitionWindowRef.current,
      currentStart: exhibitionCurrentStart,
      currentTime: currentTime,
      currentEnd: exhibitionCurrentEnd
    });

    if (isFuture) {
      handleForcePause();
      timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
      timelineRef?.current['$el'].setCustomTime(currentTime, 1);

      return;
    }

    const playerCurrentTime = Math.trunc((currentTime - exhibitionCurrentStart) / 1000);
    playerRef.current.currentTime = playerCurrentTime;

    timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
    timelineRef?.current['$el'].setCustomTime(currentTime, 1);

    handlePlayButton();
  }

  function handleCancelModalNewContent() {
    const { currentStart, currentTime, currentEnd } = exhibitionWindowMockDataToReturnAfterCancelModalRef.current;
    let exhibitionCurrentTime = estimateCurrentDateTimeWithoutDelayToLive(currentEnd);

    exhibitionWindowRef.current = {
      currentStart: currentStart,
      currentTime: currentTime,
      currentEnd: currentEnd
    }

    setExhibitionWindow({
      currentStart,
      currentTime,
      currentEnd
    })

    setIsCriticalModalOpen(false);
    timelineRef?.current['$el'].setOptions({
      ...timelineOptions,
      start: currentStart,
      end: currentEnd
    });
    timelineRef?.current['$el'].setCustomTime(currentTime, 1);
    exhibitionWindowCurrentTime.current = exhibitionCurrentTime;
    handleClearCuttingMark();
  }

  function handleTimeUpdate(e: any) {
    if (playerStatus.current === 'paused') {
      return;
    }

    if (playerStatus.current === 'loaded') {
      return;
    }

    const currentTimeOffset = Math.trunc(e.target.currentTime * 1000);
    const exhibitionCurrentTime = clipWindow.current.currentStart + currentTimeOffset;
    const exhibitionCurrentStart = exhibitionCurrentTime - ((EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) * 1000)
    const exhibitionCurrentEnd = exhibitionCurrentTime + ((EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2) * 1000);

    let clipCurrentStart = exhibitionCurrentStart;
    let clipCurrentEnd = clipCurrentStart + (clipWindow.current.durationInSeconds! * 1000);

    let currentCriticalStart = clipCurrentStart + (FIXED_CRITICAL_INTERVAL * 1000);
    let currentCriticalEnd = clipCurrentEnd - (FIXED_CRITICAL_INTERVAL * 1000);

    if (isWithinCriticalSpace(exhibitionWindowRef.current.currentTime)) {
      setIsCriticalModalOpen(true);
      handleForcePause();

      const clipWindowMockData = {
        currentStart: clipCurrentStart,
        currentEnd: clipCurrentEnd,
        criticalStart: currentCriticalStart,
        criticalEnd: currentCriticalEnd
      }

      const exhibitionWindowMockData = {
        ...exhibitionWindowRef.current,
        currentStart: exhibitionCurrentStart,
        currentTime: exhibitionCurrentTime,
        currentEnd: exhibitionCurrentEnd,
        isFuture: false,
      }

      //atualiza as referencias de mock para utilizar na confirmação do modal passada para o usuário
      clipWindowMockDataToUpdateClipWindowAfterConfirmationModal.current = clipWindowMockData;
      exhibitionWindowMockDataToUpdateExhibitionWindowAfterConfirmationModal.current = exhibitionWindowMockData;
    } else {
      exhibitionWindowRef.current = {
        currentStart: exhibitionCurrentStart,
        currentTime: exhibitionCurrentTime,
        currentEnd: exhibitionCurrentEnd
      }

      setExhibitionWindow(prev => ({
        currentTime: exhibitionCurrentTime,
        currentStart: exhibitionCurrentStart,
        currentEnd: exhibitionCurrentEnd
      }));

      if (isSeekingToDownlod.current) {
        let start = new Date(lastSelectedSeekDate.current);
        let end = new Date(exhibitionCurrentTime);

        if (moment(exhibitionCurrentTime).isBefore(lastSelectedSeekDate.current)) {
          start = new Date(exhibitionCurrentTime);
          end = new Date(lastSelectedSeekDate.current);
        }

        const criticalAreaStart = clipWindow.current.criticalStart;
        const criticalAreaEnd = clipWindow.current.criticalEnd;

        const clipArea = [start, end];


        const formattedClipDownloadDuration = calculateDiffBetweenClipDates(start.getTime(), end.getTime());
        setFormattedClipCutDuration(formattedClipDownloadDuration);

        //Fazer a duration, que é a diferença de tempos in out para formatar certo
        const items = generateTimelineRangeItems(criticalAreaStart, criticalAreaEnd, clipArea);
        timelineRef?.current['$el'].setItems(items);

      }

      timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
      timelineRef?.current['$el'].setCustomTime(exhibitionCurrentTime, 1);
      timelineRef?.current['$el'].redraw();
    }
  }

  function handleGetLastPlayerStatus() {
    if (lastStatusBeforeDrag.current === 'playing') {
      handlePlay();
    } else {
      handleForcePause();
    }
  }

  const handlePlay = async () => {
    try {
      await playerRef.current.play();
      playerStatus.current = 'playing';
      setCurrentPlayerStatus('playing');
    } catch (err) {
      console.log(err);
    }
  }

  const handleForcePause = () => {
    playerRef.current.pause();
    playerStatus.current = 'paused';
    setCurrentPlayerStatus('paused');
  }

  const handlePlayButton = useCallback(() => {
    if (playerRef.current.paused) {
      handlePlay();
    } else {
      handleForcePause();
    }
  }, [])

  
  

  const navigateInTimeline = (duration: number) => {
    let isFuture = isFutureTimestamp(exhibitionWindowRef.current.currentTime + duration);

    if (isFuture) {
      dialogContext.setDialogStatus(true);
      return;
    }

    const exhibitionWindowMockDataToBeConsumedByCancelModal = {
      ...exhibitionWindowRef.current,
      currentStart: exhibitionWindowRef.current.currentStart,
      currentTime: exhibitionWindowRef.current.currentTime,
      currentEnd: exhibitionWindowRef.current.currentEnd
    }

    exhibitionWindowMockDataToReturnAfterCancelModalRef.current = exhibitionWindowMockDataToBeConsumedByCancelModal;

    let exhibitionCurrentStart = new Date(exhibitionWindowRef.current.currentStart + duration);
    let exhibitionCurrentEnd = new Date(exhibitionWindowRef.current.currentEnd + duration);
    let exhibitionCurrentTime = new Date(exhibitionWindowRef.current.currentTime + duration);

    if (isWithinCriticalSpace(exhibitionCurrentTime.getTime())) {
      handleForcePause();
      setIsCriticalModalOpen(true);

      let clipCurrentStart = exhibitionCurrentStart.getTime();
      let clipCurrentEnd = clipCurrentStart + (clipWindow.current.durationInSeconds! * 1000);

      let currentCriticalStart = clipCurrentStart + (FIXED_CRITICAL_INTERVAL * 1000);
      let currentCriticalEnd = clipCurrentEnd - (FIXED_CRITICAL_INTERVAL * 1000);


      const clipWindowMockData = {
        currentStart: clipCurrentStart,
        currentEnd: clipCurrentEnd,
        criticalStart: currentCriticalStart,
        criticalEnd: currentCriticalEnd
      }

      const exhibitionWindowMockData = {
        ...exhibitionWindowRef.current,
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime(),
        isFuture: isFuture
      };

      clipWindowMockDataToUpdateClipWindowAfterConfirmationModal.current = clipWindowMockData;
      exhibitionWindowMockDataToUpdateExhibitionWindowAfterConfirmationModal.current = exhibitionWindowMockData;
    } else {
      if (isSeekingToDownlod.current) {
        let start = new Date(lastSelectedSeekDate.current);
        let end = exhibitionCurrentTime;

        if (moment(exhibitionCurrentTime).isBefore(lastSelectedSeekDate.current)) {
          start = exhibitionCurrentTime;
          end = new Date(lastSelectedSeekDate.current);
        }

        const criticalAreaStart = clipWindow.current.criticalStart;
        const criticalAreaEnd = clipWindow.current.criticalEnd;

        const clipArea = [start, end];

        const formattedClipDownloadDuration = calculateDiffBetweenClipDates(start.getTime(), end.getTime());
        setFormattedClipCutDuration(formattedClipDownloadDuration);

        const items = generateTimelineRangeItems(criticalAreaStart, criticalAreaEnd, clipArea);
        timelineRef?.current['$el'].setItems(items);
        timelineRef.current['$el'].redraw();
      }

      exhibitionWindowRef.current = {
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime()
      }

      setExhibitionWindow({
        ...exhibitionWindowRef.current,
        currentStart: exhibitionCurrentStart.getTime(),
        currentTime: exhibitionCurrentTime.getTime(),
        currentEnd: exhibitionCurrentEnd.getTime()
      })

      let clipCurrentStart = clipWindow.current.currentStart;
      const playerCurrentTime = Math.trunc((exhibitionCurrentTime.getTime() - clipCurrentStart) / 1000);
      playerRef.current.currentTime = playerCurrentTime;

      setTimelineWindow(EXHIBITION_WINDOW_DURATION[currentZoomIndexRef.current] / 2);
      // timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
      timelineRef?.current['$el'].setCustomTime(exhibitionCurrentTime, 1);
      timelineRef?.current['$el'].redraw();
    }
  }

  function handleDateChange(date: Date | null) {
    if (!isValid(date)) {
      setHasSelectedDate(false);
      return;
    }
    setSelectedDate(date ? date.toISOString() : new Date().toISOString());
    setHasSelectedDate(true);
  };

  async function handleSearchAndPlayClipByTimestamp() {
    const currentSelectedTimestampByUser = new Date(selectedDate).getTime();
    handleClearCuttingMark()//anula o IN em caso de pesquisa de data

    if (isNaN(currentSelectedTimestampByUser)) {
      return;
    }

    let isFuture = isFutureTimestamp(currentSelectedTimestampByUser);

    if (isFuture) {
      dialogContext.setDialogStatus(true);
      return;
    }

    handleForcePause();

    setSearchConfirmationModal(true);

    setSearchTimestampSelectedByUser(currentSelectedTimestampByUser);
  }

  async function handleConfirmSearchModal() { //OK
    setIsLoadingNewMedia(true);
    setSearchConfirmationModal(false);

    let exhibitionCurrentStart = estimateExhibitionWindowsCurrentStartByCurrentTime(searchTimestampSelectedByUser);
    let exhibitionCurrentEnd = estimateExhibitionWindowsCurrentEndByCurrentTime(searchTimestampSelectedByUser);

    let clipWindowStart = estimateClipWindowCurrentStartByCurrentTime(searchTimestampSelectedByUser);
    let clipWindowEnd = estimateClipWindowsCurrentEndByCurrentTimeByWindowsCurrentStart(clipWindowStart)

    let criticalStart = estimateClipWindowsCriticalStartByCurrentTime(searchTimestampSelectedByUser);
    let criticalEnd = estimateClipWindowsCriticalEndByCurrentTime(clipWindowStart);

    timelineRef?.current['$el'].setOptions({ start: exhibitionCurrentStart, end: exhibitionCurrentEnd });
    timelineRef?.current['$el'].setCustomTime(searchTimestampSelectedByUser, 1);

    

    exhibitionWindowRef.current = {
      currentStart: exhibitionCurrentStart,
      currentTime: searchTimestampSelectedByUser,
      currentEnd: exhibitionCurrentEnd
    }

    setExhibitionWindow({
      currentStart: exhibitionCurrentStart,
      currentTime: searchTimestampSelectedByUser,
      currentEnd: exhibitionCurrentEnd,
    })

    //currentStart
    const clipNameAndLocationName = currentClipToDisplay!.name.replace('-', '')
    await getClip(clipNameAndLocationName, clipWindowStart, clipWindow.current.durationInSeconds!).then(res => {
      clipWindow.current = {
        ...clipWindow.current,
        currentStart: clipWindowStart,
        currentEnd: clipWindowEnd,
        criticalStart: criticalStart,
        criticalEnd: criticalEnd,
        clipUUID: res.data.uuid,
        currentSource: clipNameAndLocationName!,
      }
      setAudioUrl(res.data.address);
      setIsLoadingNewMedia(false);
      playerRef.current.currentTime = FIXED_CRITICAL_INTERVAL + EXHIBITION_WINDOW_DURATION[currentZoomIndex] / 2;

      const dateFrom = formatTimestampToIsoNumber(clipWindowStart);
      const dateTo = formatTimestampToIsoNumber(clipWindowEnd);     
      
      getExhibitionReport({
        source: clipWindow.current.currentSource,
        dateFrom,
        dateTo,
        filter: ['CERTAIN']
      }).then(res => {
        timelineRecognitions.current = generateTimelineRecognitionItems(res);
        setRecognitions(timelineRecognitions.current);
        generateCreativeListByRecognitions(timelineRecognitions.current).then((response) => {
          timelineCreatives.current = response;
        });
        updateRedCriticalArea(criticalStart, criticalEnd);
      })
    }).catch(err => {
      console.log(err);

    })

  }

  function handleCancelSearchModal() { //CANCELAR
    setSearchConfirmationModal(false);
  }

  function handleCancelChangeSourceModal() { //CANCELAR
    setChangeSourceModal(false);
    setIsLoadingNewMedia(false);
    setCurrentClipToDisplay(lastSelectedSourceByUser.current)
    currentSelectedSourceByUser.current = lastSelectedSourceByUser.current;
  }

  function handleConfirmChangeSourceModal() { //OK
  //setCurrentClipToDisplay(lastSelectedSourceByUser.current);
    setChangeSourceModal(false);
    setIsLoadingNewMedia(true);
    
    clipWindow.current = {
      ...clipWindow.current,
      currentSource: currentClipToDisplay?.name ?? "POAATL"
    }
    lastSelectedSourceByUser.current = currentClipToDisplay;

    loadClippingSourcesAndRenderFirstClip();
  }

  function formatTime(segundos: number) {
    let [integer,] = String(segundos).split('.');

    let hours = parseInt(integer) / 3600;
    let minutos = (parseInt(integer) / 60) % 60;
    let segundosRestantes = parseInt(integer) % 60;

    let formattedHour = String(Math.trunc(hours)).padStart(2, '0');
    let minutosFormatados = String(Math.trunc(minutos)).padStart(2, '0');
    let segundosFormatados = String(Math.trunc(segundosRestantes)).padStart(2, '0');

    return formattedHour + ':' + minutosFormatados + ':' + segundosFormatados;
  }

  function calculateStartAndStopDifferenceAndReturnBothByCurrentTimelineRecognition() {
    
    if (!currentTimelineRecognition.current) {
      return { seek: "00:00", to: "00:30" };
    }

    const seek = (currentTimelineRecognition.current?.start.getTime() - clipWindow.current.currentStart) / 1000;
    const to = (currentTimelineRecognition.current?.end.getTime() - clipWindow.current.currentStart) / 1000;

    return { seek: formatTime(seek), to: formatTime(to) }
  }

  function calculateStartAndStopDifferenceAndReturnBoth() {
    const seek = (cuttingMark.start - clipWindow.current.currentStart) / 1000;
    const to = (cuttingMark.end - clipWindow.current.currentStart) / 1000;

    return { seek: formatTime(seek), to: formatTime(to) }
  }

  const CuttingIcon = ({ icon = 'busy' }: CuttingIconProps) => {
    const Icon = {
      available: <EventAvailable className="cutting-button" />,
      busy: <EventBusy className="cutting-button" />
    }

    return (
      <>{Icon[icon]}</>
    )
  }

  const handleRequestUserPermissionToStartCuttingDownload = () => {
    handleForcePause();
    setIsClipDialogOpen(true);
  }

  const handleClearCuttingMark = (status?: { keepFirstEntry: boolean }) => {
    setIsClipDialogOpen(false);

    if (status?.keepFirstEntry) {
      setCuttingMark(prev => ({
        ...prev,
        end: 0
      }));

      return;
    }

    setCuttingMark(() => ({
      start: 0,
      end: 0
    }));

    isSeekingToDownlod.current = false;
    handleResetFormattedClipDownloadArea()

    updateRedCriticalArea(clipWindow.current.criticalStart, clipWindow.current.criticalEnd)
  }

  function handleResetFormattedClipDownloadArea() {
    setFormattedClipCutDuration('00:00');
  }

  const handleConfirmClipgDownload = () => {
    setIsLoadingNewMedia(true);
    handleTrimAudio();
    setIsClipDialogOpen(false);
    handleClearCuttingMark();
  }

  const handleSeekSelection = () => {
    //Reseta o estado do icon zerando o valor do start
    if (cuttingMark.start > 0) {
      handleClearCuttingMark();
      isSeekingToDownlod.current = false;
      handleResetFormattedClipDownloadArea()

      return;
    }

    //Inverte os valores de start e end caso o start seja maior que o end
    if (exhibitionWindowRef.current.currentTime > cuttingMark.end && cuttingMark.end > 0) {
      setCuttingMark(prev => ({
        ...prev,
        start: cuttingMark.end,
        end: exhibitionWindowRef.current.currentTime
      }));

      handleRequestUserPermissionToStartCuttingDownload();

      return;
    }

    setCuttingMark(prev => ({
      ...prev,
      start: exhibitionWindowRef.current.currentTime
    }));

    if (cuttingMark.end) {
      handleRequestUserPermissionToStartCuttingDownload();
    }

    isSeekingToDownlod.current = true;
    lastSelectedSeekDate.current = exhibitionWindowRef.current.currentTime;
  }

  const handleToSelection = () => {

    //Reseta o valor de zero caso já existe um valor selecionado anteriormente
    if (cuttingMark.end > 0) {
      setCuttingMark(prev => ({
        ...prev,
        end: 0
      }));

      handleResetFormattedClipDownloadArea();

      return;
    }

    //Inverte os valores de end e start caso end seja menor que start
    if (exhibitionWindowRef.current.currentTime < cuttingMark.start) {
      setCuttingMark(prev => ({
        ...prev,
        end: prev.start,
        start: exhibitionWindowRef.current.currentTime,
      }));


      setTimeout(() => {
        handleRequestUserPermissionToStartCuttingDownload();
      }, 1500)

      return;
    }

    setCuttingMark(prev => ({
      ...prev,
      end: exhibitionWindowRef.current.currentTime
    }));

    if (cuttingMark.start > 0) {
      handleRequestUserPermissionToStartCuttingDownload();
    }
  }

  const downloadAudio = async (seek: string, to: string) => {
    let address = trimUrlPattern
    .replace("{seek}", seek)
    .replace("{to}", to)
    .replace("{clipId}", clipWindow.current.clipUUID);

  const storage = getLocalStorageData();

  let config = {
    method: 'get',
    headers: {
      'Authorization': `Bearer ${storage.token}`
    },
    credentials: 'include'
  } as any;

  try {
    const response = await fetch(address, config)

    if (response.status !== 200) {
      return;
    }

    if (!response.body) return;

    const reader = response.body.getReader();

    let chunks = [];
    while (true) {
      const { done, value } = await reader.read();
      if (done) {
        setIsLoadingNewMedia(false);
        break;
      }

      chunks.push(value);
    }
    let blob = new Blob(chunks);

    var file = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = file;
    a.download = "trimmed-" + Math.random() * 10023 + ".mp3";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    console.log(error);
  }
  }

  const handleDownloadRecognition = async() => {
    const { seek, to } = calculateStartAndStopDifferenceAndReturnBothByCurrentTimelineRecognition();
    setIsLoadingNewMedia(true);
    setDisableDownloadButton(true);
    await downloadAudio(seek, to);
    setDisableDownloadButton(false);
    handleCloseContextMenu();
  }

  const handleTrimAudio = async () => {
    const { seek, to } = calculateStartAndStopDifferenceAndReturnBoth();
    downloadAudio(seek, to);
  }

  useEffect(() => {
    loadClippingSourcesAndRenderFirstClip();
    let userData = getLocalStorageData();

    axiosCallHandler({ method: 'GET', url: `/users/${userData?.username}` })
      .then((currentUserServerData: UserData) => {
        axiosCallHandler({ method: 'GET', url: '/clipping-sources' }).then(res => {
          let response: ClippingSourceShape[] = [];

          for (let i = 0; i < res.length; i++) {
            let item = res[i] as ClippingSourceShape;
            if (currentUserServerData.groups?.includes(item.name) && item.enabled) {
              response.push(item)
            }
          }

          setClippings(response);
          setFilteredClips(response);
        });
      })

    window?.addEventListener('keydown', (e: any) => {
      if (e.target?.id === "filter-input") {
        return;
      }

      if (e.key === 'Space' || e.keyCode === 32) {
        handlePlayButton();
      }
    })
  }, [handlePlayButton]);

  useEffect(handleFilter, [debouncedFilterTerm]);
  useEffect(() => {
    if (!currentClipToDisplay) {
      return;
    }
    currentSelectedSourceByUser.current = currentClipToDisplay;

    if (clipWindow.current.clipUUID === '') {
      lastSelectedSourceByUser.current = currentClipToDisplay;
      loadClippingSourcesAndRenderFirstClip();
      return;
    }

    if (currentSelectedSourceByUser.current === lastSelectedSourceByUser.current) {
      return;
    }
    setChangeSourceModal(true);


  }, [currentClipToDisplay])

  return (
    <div>
      <ThemeProvider theme={(outerTheme) => createTheme(outerTheme, ptBR)}>
        <PlayerLayout>
          <Box style={{ height: '100dvh', width: '100%' }}>
            {isGloboCurrentApp() ?
              <></> :
              <div style={{ height: '180px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                <MediaproIcon
                  src={MediaproLogo}
                  alt="logo Mediapro"
                />
              </div>
            }
            <SearchWrapper>
              <Filter value={filter} onChange={setFilter} id="filter-input" placeholder="Escolher a praça" />
            </SearchWrapper>
            <CardsContainer>
              {
                filteredClips?.map((clip) => {
                  return (
                    <Card
                      
                      {...clip}
                      isFocused={currentClipToDisplay?.name === clip.name}
                      key={clip.name}
                      label={clip.location_label}
                      text={clip.channel_label}
                      setCurrentClip={(clipName) => {
                        
                        setCurrentClipToDisplay(clipName);
                        
                      }}
                    />
                  )
                })
              }
            </CardsContainer>
          </Box>
          <PlayerArea>
            {/* <pre>{JSON.stringify({ 'exhibition-current-time': new Date(exhibitionWindowRef.current.currentTime) })}</pre> */}

            <div style={{ display: 'none' }}>
              <ReactHlsPlayer
                src={audioUrl}
                // src={STATIC_URL}
                autoPlay={false}
                controls={true}
                playerRef={playerRef}
                width="100%"
                height="auto"
                onPause={() => playerStatus.current = 'paused'}
                onPlay={() => playerStatus.current = 'playing'}
                onTimeUpdate={handleTimeUpdate}
              />
            </div>
            {
              playerStatus.current === "loading" ?
                (<CircularProgress disableShrink />)
                :
                (
                  currentClipToDisplay && (
                    <React.Fragment>
                      {isGloboCurrentApp() ? (
                        <div style={{ maxWidth: 1280, width: '100%', backgroundColor: '#0D3EFB', padding: '10px 8px', marginBottom: 10, borderRadius: 4 }}>
                          <WhiteTextTypography variant="body1" >{currentClipToDisplay?.playerLabel}</WhiteTextTypography>
                        </div>
                      ) : (
                        <div style={{ maxWidth: 1280, width: '100%', backgroundColor: '#E94E1B', padding: '10px 8px', marginBottom: 10, borderRadius: 8 }}>
                          <WhiteTextTypography variant="body1" >{currentClipToDisplay?.playerLabel}</WhiteTextTypography>
                        </div>
                      )}


                      <div className='audio-datepicker-wrapper'>

                        <section style={{ display: 'flex', gap: '1rem' }}>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <SearchKeyboardDateTimePicker
                              id="datetimepicker"
                              value={selectedDate}
                              onChange={handleDateChange}
                              format="dd/MM/yyyy HH:mm:ss"
                              disableFuture
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              maxDateMessage="Data inválida"
                              InputProps={{
                                disableUnderline: true,
                                style: { padding: '0px 10px', height: '26px' }
                              }}
                              InputAdornmentProps={{
                                style: { display: 'none' }
                              }}
                              disableToolbar
                            />
                          </MuiPickersUtilsProvider>

                          <SearchButton
                            onClick={handleSearchAndPlayClipByTimestamp}
                            disabled={!hasSelectedDate}
                            startIcon={<SearchIcon />}
                          >
                            <SearchButtonTypography className="search-button">Pesquisar</SearchButtonTypography>
                          </SearchButton>
                        </section>
                        <IconsWrapper activeBorder={cuttingMark.start > 0}>

                          <CuttingButton
                            startIcon={<CuttingIcon icon={cuttingMark.start ? 'available' : 'busy'} />}
                            onClick={handleSeekSelection}
                            size='medium'
                          ><CuttingButtonTypography className="cutting-button">In</CuttingButtonTypography>
                          </CuttingButton>

                          <div>
                            <CuttingTimecodeTypography>
                              {formattedClipCutDuration}
                            </CuttingTimecodeTypography>
                          </div>

                          <CuttingButton
                            disabled={cuttingMark.start <= 0}
                            startIcon={<CuttingIcon icon={cuttingMark.end ? 'available' : 'busy'} />}
                            onClick={handleToSelection}
                            size='medium'
                          ><CuttingButtonTypography className="cutting-button">Out</CuttingButtonTypography>
                          </CuttingButton>
                        </IconsWrapper>
                      </div>
                      <TimelineWrapper isLoadingNewContent={isLoadingNewMidia}>
                        <div className='loader-wrapper'>
                          <div className="loader"></div>
                        </div>
                        {
                          currentClipToDisplay && (
                            <Box id="audio-timeline"
                            className="audio-timeline">

                              <Timeline
                                
                                ref={timelineRef}
                                options={timelineOptions}
                                rangechangedHandler={rangeChangedHandler}
                                rangechangeHandler={rangeChangeHandler}
                                contextmenuHandler={contextmenuHandler}
                                doubleClickHandler={doubleClickHandler}
                                items={recognitions}
                              />
                            </Box>
                          )
                        }

                      </TimelineWrapper>

                      <Menu
                        aria-modal
                        aria-hidden
                        keepMounted
                        open={contextMenuPosition.mouseY !== null}
                        onClose={handleCloseContextMenu}
                        anchorReference="anchorPosition"
                        anchorPosition={
                          contextMenuPosition.mouseY !== null && contextMenuPosition.mouseX !== null
                            ? { top: contextMenuPosition.mouseY, left: contextMenuPosition.mouseX }
                            : undefined
                        }
                        PaperProps={{  
                            style: {  
                              width: 320,  
                              maxWidth: 320,
                              
                            },  
                        }} 
                        MenuListProps={{
                          style: {  
                            width: 320,  
                            maxWidth: 320,
                            padding: "20px 20px",
                          },  
                        }}
                      >
                        <ContextMenuDownloadButton disabled={disableDownloadButton} onClick={handleDownloadRecognition} startIcon={<CloudDownloadOutlinedIcon/>}>Download</ContextMenuDownloadButton>
                        
                        <ContextMenuInfoTypography><InfoOutlinedIcon></InfoOutlinedIcon>INFORMAÇÕES</ContextMenuInfoTypography>
                        <ContextMenuTypeTypography>Titúlo:</ContextMenuTypeTypography>
                        <ContextMenuDescTypography>{currentTimelineCreative.current?.metadata.title}</ContextMenuDescTypography>
                        <ContextMenuTypeTypography>Anunciante:</ContextMenuTypeTypography>
                        <ContextMenuDescTypography>{currentTimelineCreative.current?.metadata.advertiser}</ContextMenuDescTypography>
                        <ContextMenuTypeTypography>Duração:</ContextMenuTypeTypography>
                        <ContextMenuDescTypography>{currentTimelineCreative.current?.metadata.duration} segundos</ContextMenuDescTypography>
                      </Menu>

                      <TimeControllerContainer>
                        <TimeReference>{moment(exhibitionWindowRef.current.currentTime).format('HH:mm:ss')}</TimeReference>
                        <DateReference>{moment(exhibitionWindowRef.current.currentTime).locale('pt-br').format('dddd DD [de] MMMM')}</DateReference>
                        <section className="zoom-controller">
                          <ZoomButton onClick={handleZoomOut} disabled={currentZoomIndex === 0} >
                            <ZoomOut />
                          </ZoomButton>
                          <ZoomButton onClick={handleZoomIn} disabled={currentZoomIndex === 3} >
                            <ZoomIn />
                          </ZoomButton>

                        </section>
                      </TimeControllerContainer>
                      <PlayerControllerContainer isLoadingNewContent={isLoadingNewMidia}>
                        <section className="controller">
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToFuture['1_DAY'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>+1d</NavigationButtonTypography></NavigationButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToFuture['30_MINUTES'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>+30m</NavigationButtonTypography></NavigationButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToFuture['3_MINUTES'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>+3m</NavigationButtonTypography></NavigationButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToFuture['30_SECONDS'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>+30s</NavigationButtonTypography></NavigationButton>
                          <PlayPauseButton onClick={handlePlayButton} >
                            {
                              playerStatus.current === 'playing' ? (
                                <Pause width={40} key={1} />
                              ) : (
                                <PlayArrow width={40} key={2} />
                              )
                            }
                          </PlayPauseButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToPast['30_SECONDS'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>-30s</NavigationButtonTypography></NavigationButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToPast['3_MINUTES'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>-3m</NavigationButtonTypography></NavigationButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToPast['30_MINUTES'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>-30m</NavigationButtonTypography></NavigationButton>
                          <NavigationButton onClick={() => navigateInTimeline(NavigateToPast['1_DAY'])} disabled={isLoadingNewMidia}><NavigationButtonTypography>-1d</NavigationButtonTypography></NavigationButton>
                        </section>
                      </PlayerControllerContainer>
                      
                      
                      
                      <SimpleDialog
                        openDialog={dialogContext.dialogStatus}
                        setOpenDialog={dialogContext.setDialogStatus}
                        dialogText="Não é possível pesquisar clipes futuros"
                      />
                      {/* #### CRITICAL AREA DIALOG #### */}
                      <AudioDialog
                        aria-modal
                        isOpen={isCriticalModalOpen}
                        onClose={() => {
                          setIsCriticalModalOpen(false)
                        }
                        }
                        title="Requisição de novo conteúdo"
                        text="Será necessário fazer o download de um novo conteúdo para análise"
                      >
                        <ButtonOutlined onClick={handleCancelModalNewContent} variant="outlined">
                          Cancelar
                        </ButtonOutlined>
                        <ButtonContained onClick={handleConfirmationModalNewContent} autoFocus variant="contained">
                          OK
                        </ButtonContained>
                      </AudioDialog>

                      {/* #### CLIP DIALOG */}
                      <AudioDialog
                        aria-modal
                        isOpen={isClipDialogOpen}
                        onClose={() => {
                          setIsClipDialogOpen(false);
                          handleClearCuttingMark({ keepFirstEntry: true });
                        }}
                        title='Fazer download de conteúdo'
                        text="Você deseja fazer o download deste audio?"
                      >
                        <ButtonOutlined onClick={() => handleClearCuttingMark({ keepFirstEntry: true })}  variant="outlined">
                          Cancelar
                        </ButtonOutlined>
                        <ButtonContained onClick={handleConfirmClipgDownload} autoFocus variant="contained">
                          OK
                        </ButtonContained>
                      </AudioDialog>
                      {/* #### SEARCH DIALOG */}
                      <AudioDialog
                        aria-modal
                        isOpen={searchConfirmationModal}
                        onClose={() => setSearchConfirmationModal(false)}
                        title="Fazer download de conteúdo"
                        text="Você deseja buscar esta data?"
                      >
                        <ButtonOutlined onClick={handleCancelSearchModal} variant="outlined">
                          Cancelar
                        </ButtonOutlined>
                        <ButtonContained onClick={handleConfirmSearchModal} autoFocus variant="contained">
                          OK
                        </ButtonContained>
                      </AudioDialog>
                      {/* #### CHANGE SROUCE ### */}
                      <AudioDialog
                        aria-modal
                        isOpen={changeSourceModal}
                        onClose={() => setChangeSourceModal(false)}
                        title='Mudar praça'
                        text='Você deseja alterar praça?'
                      >
                        <ButtonOutlined onClick={handleCancelChangeSourceModal} variant="outlined">
                          Cancelar
                        </ButtonOutlined>
                        <ButtonContained onClick={handleConfirmChangeSourceModal} autoFocus variant="contained">
                          OK
                        </ButtonContained>
                      </AudioDialog>
                      {/* #### NOT FOUND ON LOAD CLIP ### */}
                    </React.Fragment>
                  )
                )
            }
          </PlayerArea>
        </PlayerLayout>
      </ThemeProvider>
    </div>
  )
};

export default AudioPlayer;